export const GATES_MANUALLY_DISABLED_LEAVE_BETA = ['HelpDesk:NotePoweredCollaboration', 'egu:PrivateBeta'];
export const EnrollTypes = {
  PORTALS_ONLY: 'PORTALS_ONLY',
  USERS_AND_PORTALS: 'USERS_AND_PORTALS',
  USERS_ONLY: 'USERS_ONLY',
  ORGANIZATIONS_ONLY: 'ORGANIZATIONS_ONLY'
};
export const EnrollmentStatuses = {
  CANNOT_ENROLL: 'CANNOT_ENROLL',
  CANNOT_ENROLL_TRIAL_PORTAL: 'CANNOT_ENROLL_TRIAL_PORTAL',
  ENROLLED_CANNOT_LEAVE: 'ENROLLED_CANNOT_LEAVE',
  NOT_ENROLLED: 'NOT_ENROLLED',
  ORGANIZATION: 'ORGANIZATION',
  PENDING_APPROVAL: 'PENDING_APPROVAL',
  PORTAL: 'PORTAL',
  USER: 'USER'
};
export const dateFieldForCategory = {
  all: 'stageDate',
  'in-beta': 'stageDate',
  'in-development': 'stageDate',
  live: 'releaseDate',
  sunset: 'releaseDate',
  recommended: 'stageDate',
  'new-to-you': 'stageDate',
  'scheduled-for-release': 'releaseDate',
  'your-betas': 'stageDate'
};
export const PRODUCT_UPDATE_TYPES = {
  IMAGE: 0,
  NO_IMAGE: 1
};
export const ScheduledUpdatesViews = {
  CALENDAR: 'CALENDAR',
  TABLE: 'TABLE'
};
export const EnrollmentStatusesForBetaStatus = {
  pending: ['PENDING_APPROVAL'],
  enrolled: ['USER', 'PORTAL', 'ENROLLED_CANNOT_LEAVE'],
  'not-enrolled': ['NOT_ENROLLED', 'CANNOT_ENROLL'],
  none: ['NONE']
};